import { useContext, useEffect, useMemo } from 'react';

import { Form as FormAntd } from 'antd';

import { GenericDataFormContext } from '../../../../../../../shared/contexts';

import { StepTwoFormContext } from '../../../../contexts';
import {SelectForm} from '../../../../../../../../../../../shared/components/Form';
import { ValidateForm } from '../../../../../../../../../../../shared/utils';
import { ColSize, ContentSection, RowSize } from '../../../../../../../../../../../shared/components';

import './index.css'
interface PropertyDataSectionProps {
  id:             number;
  duplicateId?:   number
}

export const PropertyDataSection = ({ id, duplicateId }: PropertyDataSectionProps) => {
  const validateForm = new ValidateForm();

  const { 
    provinceList,
    getLocalitiesPerProvince,
    isLoadingLocalities,
    isLoadingProvinceList,
    setLocalities,
    getLocalitiesByProvinceFromState,
  } = useContext(GenericDataFormContext);

  const { stepTwoForm } = useContext(StepTwoFormContext);

  const provinceFormItemName = `province-tab-${id}`;
  const provinceSelected: string = FormAntd.useWatch(provinceFormItemName, stepTwoForm);

  const localities = useMemo(() => getLocalitiesByProvinceFromState(provinceSelected), [getLocalitiesByProvinceFromState, provinceSelected]);

  const onSelectProvince = async () => {
    stepTwoForm?.resetFields([`location-tab-${id}`]);
    setLocalities([]);
  };

  useEffect(() => {
    if ( provinceSelected?.length ) {
      getLocalitiesPerProvince( provinceSelected )
    }
  }, [ provinceSelected, getLocalitiesPerProvince ]);

  useEffect(() => {
    if (duplicateId) {
      const allFieldsValues = stepTwoForm?.getFieldsValue(true);
  
      const duplicatedFieldsValues = Object.keys(allFieldsValues).reduce((acc, key) => {
        if (key.includes(`-tab-${duplicateId}`)) {
          const newKey = key.replace(`-tab-${duplicateId}`, `-tab-${id}`);
          acc[newKey] = allFieldsValues[key];
        }
        return acc;
      }, {} as Record<string, any>);
  
      stepTwoForm?.setFieldsValue(duplicatedFieldsValues);
    }
  }, [duplicateId, id, stepTwoForm]);

  useEffect(() => {
    setLocalities([]);
  }, [])

  return (
    <ContentSection title='Datos del bien' level='h3'>
      <RowSize>
        <ColSize size={25}>
          <SelectForm
            formProps={{
              label: 'Provincia:',
              name: `province-tab-${id}`,
              rules: validateForm.generateRules({
                label: 'provincia',
                rules: ['required'],
              }),
            }}
            selectProps={{
              loading: isLoadingProvinceList ,
              onSelect: onSelectProvince,
              options: provinceList,
              showSearch: true,
            }}
          />
        </ColSize>

        <ColSize size={25}>
          <SelectForm
            formProps={{
              label: 'Localidad:',
              name: `location-tab-${id}`,
              rules: validateForm.generateRules({
                label: 'localidad',
                rules: ['required'],
              }),
            }}
            selectProps={{
              disabled: isLoadingLocalities || !localities?.length ,
              loading: isLoadingLocalities ,
              options: localities,
              showSearch: true,
            }}
          />
        </ColSize>
      </RowSize>
    </ContentSection>
  );
};